"use client";

import Link from "next/link";
import { DashboardChartSpend } from "@/components/dashboard.chart-spend";
// Hidden until destinations are real product links (currently docs/mailto placeholders).
// import { DashboardFooter } from "@/components/dashboard.footer";
import { DashboardHeader } from "@/components/dashboard.header";
import { DashboardLowCreditModal } from "@/components/dashboard.low-credit-modal";
import { DashboardModels } from "@/components/dashboard.models";
import { DashboardPromoModal } from "@/components/dashboard.promo-modal";
import { DashboardUsageStats } from "@/components/dashboard.usage-stats";
import { Button } from "@/components/ui/button";
import { RevealSection } from "@/components/ui/reveal-section";
import { useAuth } from "@/lib/auth";

export default function Page() {
  const { user, onboardingCompleted, isMePending } = useAuth();

  const firstName = user?.name?.split(/\s+/)[0] ?? "there";

  const showDashboard = !isMePending && user !== null && onboardingCompleted === true;

  if (!isMePending && user !== null && onboardingCompleted === false) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-6">
        <p className="max-w-sm text-center text-sm text-muted-foreground">
          Finish onboarding to use the dashboard. If you opened this link directly, continue the wizard below.
        </p>
        <Button asChild>
          <Link href="/onboarding">Continue to onboarding</Link>
        </Button>
      </div>
    );
  }

  if (!showDashboard) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <p className="text-sm text-muted-foreground">Loading…</p>
      </div>
    );
  }

  return (
    <div className="@container/main flex flex-1 flex-col gap-2">
      <div className="flex flex-col gap-4 md:gap-6">
        <RevealSection delayMs={0}>
          <DashboardHeader firstName={firstName} />
        </RevealSection>
        <RevealSection delayMs={40}>
          <DashboardUsageStats />
        </RevealSection>
        <RevealSection delayMs={60}>
          <DashboardChartSpend />
        </RevealSection>
        <RevealSection delayMs={80}>
          <DashboardModels />
        </RevealSection>
        {/* <RevealSection delayMs={100}>
          <DashboardFooter />
        </RevealSection> */}
      </div>
      <DashboardPromoModal />
      <DashboardLowCreditModal />
    </div>
  );
}
